import React from "react";

const Loader = ({ isLoading }) => {
    if (!isLoading) return null;

    return (
        <div className="Loader_loaderContainer__cu8Gt">
            <div className="Loader_loader___QBQ5">
                <div className="Loader_loaderImage__1yXsK"></div>
                <div className="Loader_loaderBorder__jbLXv"></div>
            </div>
        </div>
    );
};

export default Loader;
